var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScale(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.81,
    height: 16.81,
    viewBox: "0 0 16.81 16.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2821",
    "data-name": "Group 2821",
    transform: "translate(-8.731 -8.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "image",
    transform: "translate(8.731 8.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2811",
    "data-name": "Group 2811",
    transform: "translate(-8.5 -8.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2820",
    "data-name": "Group 2820",
    transform: "translate(8.5 8.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15729",
    "data-name": "Path 15729",
    d: "M12.23,16.56h-.166A.607.607,0,0,1,11.4,15.9a.653.653,0,0,1,.664-.662h.166a.662.662,0,1,1,0,1.323Zm-3.567,0H8.5a.666.666,0,1,1,0-1.323h.166a.666.666,0,1,1,0,1.323Zm-3.567,0H4.93a.666.666,0,1,1,0-1.323H5.1a.677.677,0,0,1,.747.662A.73.73,0,0,1,5.1,16.56ZM15.8,13a.607.607,0,0,1-.664-.662v-.165a.607.607,0,0,1,.664-.662.713.713,0,0,1,.664.662v.165C16.544,12.756,16.295,13,15.8,13ZM1.53,12.921a.677.677,0,0,1-.747-.662v-.165c0-.5.332-.662.747-.662a.73.73,0,0,1,.747.662v.165A.861.861,0,0,1,1.53,12.921ZM15.8,9.448c-.5,0-.664-.331-.664-.744V8.621a.677.677,0,0,1,.664-.744.73.73,0,0,1,.664.744v.165C16.544,9.118,16.295,9.448,15.8,9.448ZM1.53,9.366A.677.677,0,0,1,.783,8.7V8.539a.7.7,0,0,1,.747-.744.742.742,0,0,1,.747.744V8.7A.861.861,0,0,1,1.53,9.366ZM15.8,5.892c-.5,0-.664-.331-.664-.744V5.066a.677.677,0,0,1,.664-.744.73.73,0,0,1,.664.744v.165C16.544,5.562,16.295,5.892,15.8,5.892ZM1.53,5.81A.765.765,0,0,1,.7,5.066V4.983c0-.5.332-.744.83-.744a.7.7,0,0,1,.747.744v.165A.99.99,0,0,1,1.53,5.81ZM12.4,2.171H12.23c-.5,0-.664-.331-.664-.744A.73.73,0,0,1,12.23.683H12.4c.5,0,.664.331.664.744A.676.676,0,0,1,12.4,2.171Zm-3.567,0H8.663a.7.7,0,0,1-.747-.744A.677.677,0,0,1,8.663.765h.166a.7.7,0,0,1,.747.744A.725.725,0,0,1,8.829,2.171Zm-3.567,0H5.1a.7.7,0,0,1-.747-.744A.761.761,0,0,1,5.1.6h.166a.7.7,0,0,1,.747.744A.887.887,0,0,1,5.262,2.171Z",
    transform: "translate(-0.242 -0.208)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2122_copy_6",
    "data-name": "Rectangle 2122 copy 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15730",
    "data-name": "Path 15730",
    d: "M1.765.654V1.765H.654V.654H1.765M2.419,0H0V2.419H2.419V0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2122_copy_6-2",
    "data-name": "Rectangle 2122 copy 6",
    transform: "translate(0 7.439)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15731",
    "data-name": "Path 15731",
    d: "M6.839,19.433v4.306H2.533V19.433H6.839M9.371,16.9H0v9.371H9.371V16.9Z",
    transform: "translate(0 -16.9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2122_copy_6-3",
    "data-name": "Rectangle 2122 copy 6",
    transform: "translate(14.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15732",
    "data-name": "Path 15732",
    d: "M18.665.654V1.765H17.554V.654h1.112M19.319,0H16.9V2.419h2.419V0Z",
    transform: "translate(-16.9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2122_copy_6-4",
    "data-name": "Rectangle 2122 copy 6",
    transform: "translate(14.391 14.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15733",
    "data-name": "Path 15733",
    d: "M18.665,17.554v1.112H17.554V17.554h1.112m.654-.654H16.9v2.419h2.419V16.9Z",
    transform: "translate(-16.9 -16.9)",
    fill: "#fff"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScale);
export default __webpack_public_path__ + "static/media/scale.bb0f8405c6cc2a778c8bd0f56cefb702.svg";
export { ForwardRef as ReactComponent };